import Head from 'next/head';
import { GetServerSideProps } from 'next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import previewMain from '../../public/preview/preview-main.png';
import { WorksProps } from '../works/works';
import { Footer, Header } from '../../components';
import ProfePage from '../profe-page/profe-page';
import staticWorks from '../../utils/works';
import menu from '../../utils/menu';

export default function WorksPage({ works }: WorksProps) {
  return (
    <>
      <Head>
        <title>
          iOS App Development Services by Mavinx: Unleashing Apple&apos;s
          Ecosystem
        </title>
        <meta
          property="og:title"
          content="iOS App Development Services by Mavinx: Unleashing Apple's Ecosystem"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="iOS App Development Services by Mavinx: Unleashing Apple's Ecosystem"
        />
        <meta property="og:type" content="product" />

        <meta
          property="og:description"
          content="Mavinx's iOS app development services use Apple's ecosystem to build creative and compelling mobile experiences. Learn about our Swift programming, iOS frameworks, UI/UX design, and app store rules. Learn how our iOS development team blends technical expertise, creativity, and user-centered design to create high-quality and smooth iOS apps. Mavinx uses Apple's platform to create iPhone, iPad, Apple Watch, and Apple TV applications and solutions."
        />

        <meta
          name="keywords"
          content="iOS app development services, Mavinx iOS development, Apple ecosystem, innovative mobile experiences, Swift programming, iOS frameworks, UI/UX design, app store guidelines, technical proficiency, creativity, user-centered design, high-quality apps, iPhone apps, iPad apps, Apple Watch apps, Apple TV solutions, Apple platform, trusted partner, Mavinx iOS app development"
        />

        <meta
          name="description"
          content="Mavinx's iOS app development services use Apple's ecosystem to build creative and compelling mobile experiences. Learn about our Swift programming, iOS frameworks, UI/UX design, and app store rules. Learn how our iOS development team blends technical expertise, creativity, and user-centered design to create high-quality and smooth iOS apps. Mavinx uses Apple's platform to create iPhone, iPad, Apple Watch, and Apple TV applications and solutions."
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <ProfePage
        intro={{
          bg: '/ios/intro-bg.jpg',
          btn: 'Estimate my app',
          h1: 'IOS',
          h2: 'App Development',
        }}
        info="We are experts in all kinds of iOS mobile development. <br />
        Mavinx has been providing iOS App Development Services for the past 5 years and got the majority of its experience across multiple areas. We are always ready to become your helper in the custom app mobile development for iOS."
        tecnologic={{
          title: 'Platforms',
          list: [
            {
              image: '/ios/device-1.jpg',
              name: 'iPhone',
            },
            {
              image: '/ios/device-2.jpg',
              name: 'iPad',
            },
            {
              image: '/ios/device-3.jpg',
              name: 'Apple Watch',
            },
          ],
        }}
        awards={{
          title: 'awards',
          leadText:
            'Leading review & rating piatforms name us the top mobile app development company',
          leadImage: '/ios/rate.png',
          list: [
            {
              image: '/awards/item-1.jpg',
              text: 'Top Web Developers in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-2.jpg',
              text: 'Top Web Design in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-3.jpg',
              text: 'Top Swift App Development in Spain',
              title: 'Clutch',
            },
            {
              image: '/awards/item-4.jpg',
              text: 'Top Web Developers in Ukraine',
              title: 'Goodfirm',
            },
            {
              image: '/awards/item-5.jpg',
              text: 'Upwork TOP RATED 2022',
              title: 'Upwork',
            },
            {
              image: '/awards/item-6.jpg',
              text: 'Top Web Developers Companies 2020',
              title: 'Appfutura',
            },
          ],
        }}
        works={works.slice(0, 2)}
        service={{
          title: 'iOS Development Services',
          list: [
            {
              image: '/ios/service-1.jpg',
              title: 'UX and UI design',
              text: 'We feel what you need and we know how to make it convenient for users.  We guarantee the design for iOS mobile app will convey the main idea, mood and solutions of the application.',
            },
            {
              image: '/ios/service-2.jpg',
              title: 'Implementation',
              text: 'iOS mobile development needs planning, prioritizing tasks to the top, using different technologies. Our clients are following the development status and  are following the developmentin progress.',
            },
            {
              image: '/ios/service-3.jpg',
              title: 'Quality Assurance',
              text: 'Development of iOS mobile app always requires testing. The cost of all applications is that they are free of bugs. Our team prepares test plans, test cases and bug reports so that the application meets all.',
            },
            {
              image: '/ios/service-4.jpg',
              title: 'Integration Process',
              text: 'Of course, the integration of applications for iPhones and iPads is essential to improve efficiency, speed and quality. Development of mobile iOS applications does not stand still.',
            },
          ],
        }}
        devtool={{
          title: 'iOS technologies we work with',
          list: [
            { image: '/ios/swift.png', name: 'Swift' },
            { image: '/ios/objective-c.png', name: 'Objective C' },
            { image: '/ios/xcode.png', name: 'Xcode' },
            { image: '/ios/uikit.png', name: 'UIKit' },
            { image: '/ios/core-data.png', name: 'Core Data' },
          ],
        }}
      />
      <Footer />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<WorksProps> = async () => {
  try {
    const works = staticWorks;
    return {
      props: {
        works,
      },
    };
  } catch {
    return {
      notFound: true,
    };
  }
};
